global.$ = global.jQuery = require('jquery');

import * as L from "leaflet";

export class MapView {

	constructor() {

		if ( $('#map').length && $('.content-bryter-map-view').length && 'undefined' != typeof geoChartData) {
			this.options = geoChartData.options;
			this.render();
			this.map = L.map('map', {
				attributionControl: false
			});
			this.currentlySelectedLayer = null;

		}
	}

	async render() {
		const _this = this;
		let fetchUrl;

		if(this.options.map === 'eus') {
			fetchUrl = BRYTER.pluginAssetsSrcUrl + 'js/data/eu-countries.json';
		} else if(this.options.map === 'us') {
			fetchUrl = BRYTER.pluginAssetsSrcUrl + 'js/data/us-states.json';
		} else if(this.options.map === 'eu') {
			fetchUrl = BRYTER.pluginAssetsSrcUrl + 'js/data/eu-member-states.json';
		} else if(this.options.map === 'efta') {
			fetchUrl = BRYTER.pluginAssetsSrcUrl + 'js/data/efta-countries.json';
		} else if(this.options.map === 'eea') {
			fetchUrl = BRYTER.pluginAssetsSrcUrl + 'js/data/eea-countries.json';
		} else if(this.options.map === 'world') {
			fetchUrl = BRYTER.pluginAssetsSrcUrl + 'js/data/world-countries.json';
		}

		fetch(fetchUrl)
			.then(response => response.json())
			.then(incoming => {
				const countryDataArray = Object.values(geoChartData.countryData);

				const baseMap = "https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png",
					mapZoomBoundaries = {
						maxZoom: 11,
						minZoom: 2,
					},
					polyStatesData = incoming,
					data = this.extendGeoJson( polyStatesData, countryDataArray)

				this.map.setView([this.options.initial_view.lat, this.options.initial_view.lng], this.options.initial_view.z);

				/*
				The next line if commented out will hide the base map
				 */
				L.tileLayer(baseMap, mapZoomBoundaries).addTo(_this.map)

				let countriesWithData = [];
				this.geoMap = L.geoJson(data, {
					clickable: true,
					style: function (feature) {
						let countryName;
						if(_this.options.map === 'us') {
							countryName = feature.properties.name;
						} else {
							countryName = feature.properties.ADMIN;
						}
						const shortCountryName = feature.properties.ISO_A3;

						if(_this.options.add_colors_only_if_has_data) {
							countryDataArray.forEach(function(item) {
								if (item.country == countryName && _this.options.map !== 'us') {
									countriesWithData.push(shortCountryName);
								}

								if (item.country == countryName && _this.options.map === 'us') {
									countriesWithData.push(countryName);
								}
							});

							if(countriesWithData.includes(shortCountryName) && _this.options.map !== 'us') {
								return _this.mapStyle(shortCountryName, 'has_data');
							} else if(countriesWithData.includes(countryName) && _this.options.map === 'us') {
								return _this.mapStyle(countryName, 'has_data');
							} else {
								return _this.mapStyle(countryName, 'default');
							}
						} else {
							if(countriesWithData.includes(shortCountryName) && _this.options.map !== 'us') {
								return _this.mapStyle(shortCountryName, 'has_data');
							} else if(_this.options.map === 'us') {
								return _this.mapStyle(countryName, 'has_data');
							} else {
								return _this.mapStyle(countryName, 'default');
							}
						}
					},
					// style: style(min, max),
					onEachFeature: _.bind(_this.onEachFeature, _this)
				}).addTo(_this.map);

				this.geoMap.eachLayer(function (layer) {
					// console.log('layer.feature::', layer.feature)
					const popoverContent = _this._renderPopover(layer.feature)

					if ( popoverContent.length ) {
						layer.bindPopup( popoverContent, {
							keepInView: true,
						} )
					}

					layer.on('popupclose', function() {
						_this.resetHighlight(layer);
					})
				});

				/*
				Display map legend
				 */
				if(_this.options.legend) {
					const legend = L.control({position: 'bottomright'});

					legend.onAdd = function (map) {

						const div = L.DomUtil.create('div', 'info legend');
						const colorsValues = _this.options.colors.colors_values;
						const labels = [];

						if(colorsValues) {
							Array.from(colorsValues).forEach(function(item) {
								labels.push(`<div class="legend-row"><i style="background:${item.color}"></i>${item.db_column_value}</div>`);
								console.log(item)
							});
						}

						div.innerHTML = labels.join(' ');
						return div;
					};

					legend.addTo(this.map);
				}
			})
			.catch(error => {
				// Handle any errors that occur during the fetch request
				console.log('Error:', error);
			});
	}

	getColor(feature, data) {
		const foundIndex = data.findIndex(item => item.country === feature);

		if(foundIndex){
			let color = data[foundIndex] && data[foundIndex].color ? data[foundIndex].color : '';

			return color;
		}
	}


	actionButton(item) {
        let buttons = []
        // console.log('actionButton::', item.name, item.value)
        if(item.name === 'action' && item.value.length ) {
            // console.log('actionButton', item.value)
            for (let btn of item.value) {
                buttons.push(`<a href="${btn.url}" class="Btn Btn--small margin-right-4 color-blue ${btn.headless_module ? 'headless-module' : ''}">${ 'text-button' == btn.button_type ? btn.button_text : 'icon-button' == btn.button_type ? '<span class="' + btn.button_icon + '"></span>' : '' }</a>`)
            }
        }
        return buttons.length ? `<div class="Popover__footer">${buttons.join('')}</div>` : ''
        
    }

    contentAreaItem(item) {
        if(item.name !== 'action') {
            return `<div class="mb-1">
                    <div class="caption-uppercase color-900">${item.name}</div>
                    <div>${item.value}</div>
                </div>`;
        }
    }

	_renderPopover( feature ) {
		// var obj = feature.event.extendedProps;
		const _this = this

		let obj = {
			clickable_el: false,
			heading: feature.properties.heading ? feature.properties.heading : '',
			props: feature.properties.props ? feature.properties.props : []
		}

		if ( !obj.props.length && !obj.heading ) {
			return ''
		}

        // console.log('popover_offset_h::', Math(popover_offset_h)
        const popover = 
        `<div class="Popover bryter-calendar-popover" data-clickable="${ obj.clickable_el !== false ? 'true' : 'false' }" data-clickable-url="${ obj.clickable_el ? obj.clickable_el.url : '' }">
                        <div class="Popover__header">
                            <h4 class="title-5 text-uppercase">${obj.heading}</h4>
                            <button type="button" class="Btn-icon Btn-icon--tiny" onclick="$('.bryter-calendar-popover').remove()">
                                <svg focusable="false" width="16" height="16" viewBox="0 0 16 16" 	xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.2589 2.66669L7.99984 6.9265L3.74079 2.66669L2.6665 3.74097L6.92555 8.00002L2.6665 12.2591L3.74079 13.3334L7.99984 9.07431L12.2589 13.3334L13.3332 12.2591L9.07412 8.00002L13.3332 3.74097L12.2589 2.66669Z" />
                                </svg>
                            </button>
                        </div>

                        <div class="Popover__section Stack Stack--small">
                            ${Object.values(obj.props).map(_this.contentAreaItem).join("")}
                        </div>
                        
                        ${Object.values(obj.props).map(_this.actionButton).join("")}
                    </div>`;
        // info.el.insertAdjacentHTML('afterend', popover);
        return popover
	}

	extendGeoJson(_worldGeoJson, countryData) {
	  	//TODO: refactor, this is a hack

	  	return countryData.reduce((acc, curr) => {
	    	let currFull = acc.find((x) => x.properties.name === curr.country);

			if(!currFull) {
				currFull = acc.find((x) => x.properties.ADMIN === curr.country);
			}
	    	if (currFull) {
	      		// currFull.properties.value = curr.value;
	      		currFull.properties.props = curr.props;
	      		currFull.properties.heading = curr.heading;
	    	}

	    	return acc;
	  	}, _worldGeoJson.features)
	}

	binTooltipToLayer(layer) {
	  layer.bindTooltip(
	    `${layer.feature.properties.name}`
	  );
	}

	highlightFeature(e) {

		const _this = this,
			layer = e.target

		layer.setStyle({
			fillColor: _this.options.colors.hover_color,
			dashArray: ''
		});

		if (!L.Browser.ie && !L.Browser.opera && !L.Browser.edge) {
			layer.bringToFront();
		}
	}

    resetHighlight(e) {
		if (this.currentlySelectedLayer && this.currentlySelectedLayer === e.target && this.currentlySelectedLayer.isPopupOpen()) {
			return;
		}

		this.geoMap.resetStyle(e.target);
    }

    zoomToFeature(e) {
       	this.map.fitBounds(e.target.getBounds());
    }

	currentlySelected(e) {
		const _this = this,
			layer = e.target

		// Remove highlight from previously selected layer
		if (this.currentlySelectedLayer) {
			this.resetHighlight(this.currentlySelectedLayer);
		}

		// Apply highlight to clicked layer
		layer.setStyle({
			fillColor: this.options.colors.selected_color,
			dashArray: ''
		});

		this.currentlySelectedLayer = layer;

		if (!L.Browser.ie && !L.Browser.opera && !L.Browser.edge) {
			layer.bringToFront();
		}
	}

    onEachFeature(feature, layer) {
    	const _this = this

        layer.on({
			click: _.bind(_this.currentlySelected, _this),
            mouseover: _.bind(_this.highlightFeature, _this),
            mouseout: _.bind(_this.resetHighlight, _this),
            // click: _.bind(_this.zoomToFeature, _this)
        });
    }

	mapStyle(feature, option) {
		const _this = this;
		const defaultFillColor = _this.options.colors[option].fill_color ? _this.options.colors[option].fill_color : '';
		let color = this.getColor(feature, _this.options.group_db_column) ? this.getColor(feature, _this.options.group_db_column) : defaultFillColor;

		return {
			stroke: _this.options.colors[option].stroke ? _this.options.colors[option].stroke : true,
			weight: 1,
			opacity: _this.options.colors[option].opacity ? _this.options.colors[option].opacity : 0,
			color: _this.options.colors[option].color ? _this.options.colors[option].color : '#fff',
			fill: true,
			fillColor: color,
			fillOpacity: _this.options.colors[option].fill_opacity ? _this.options.colors[option].fill_opacity : 1,
			className: feature
		}
	}
}